
import { useEffect, useState } from "react"
import { useEmpleadoStore } from "../stores/useEmpleadoStore"
import url from "../api/url"
import { elToast } from "../functions/Alerta";


export default function useAutorizacionSalida() {

    const aaa = new Date();
    const year = aaa.getFullYear();
    const month = ("0" + (aaa.getMonth() + 1)).slice(-2);
    const day = ("0" + aaa.getDate()).slice(-2);
    const hoy = `${year}-${month}-${day}`


    const [formSalida, setFormSalida] = useState({
        motivo: '',
        hora_salida: '',
        // hora_regreso: ''
    })
    const [quienAutoriza, setQuienAutoriza] = useState(0)
    const [jefes, setJefes] = useState([])
    const [cargando, setCargando] = useState(false)
    const [cargandobtn, setCargandobtn] = useState(false)
    const objLogueado = useEmpleadoStore(state => state.objLogueado)
    const { URL: URL_MIO, SERVIDOR } = url()
    const [alertaCamposRequeridos, setAlertaCamposRequeridos] = useState(false)
    const [cargandoDocumento, setCargandoDocumento] = useState(false)
    const [fecha, setFecha] = useState(hoy)
    // const [camposVacios, setCamposVacios] = useState(false)


    // funciones
    function traerJefes() {
        if (!objLogueado.email) {
            return
        }

        setCargando(true)
        let body = new FormData()
        body.append('email', objLogueado.email)
        body.append('funcion', 'buscarJefes')

        fetch(URL_MIO, {
            method: 'post',
            body
        })
            .then(a => a.json())
            .then(r => {
                setJefes(r)
            })
            .catch(a => {
                alert('Hubo un error al mostrar la lista de jefes, por favor intentalo nuevamente.')
            })
            .finally(() => {
                setCargando(false)
            })

    }


    function guardarSalida() {

        let motivo = formSalida.motivo.trim()
        let hora_salida = formSalida.hora_salida.trim()
        // let hora_regreso = formSalida.hora_regreso.trim()

        if (motivo.length > 0 && hora_salida.length > 0) {

            setAlertaCamposRequeridos(false)
            setCargandobtn(true)
            elToast('Guardando...', 'esperar')
            // setCamposVacios(false)

            let body = new FormData()
            body.append('motivo', motivo)
            body.append('hora_salida', hora_salida)
            // body.append('hora_regreso', hora_regreso)
            body.append('quienautoriza', quienAutoriza)
            body.append('fecha', fecha)
            body.append('email', objLogueado.email)
            body.append('funcion', 'guardarSalida')

            fetch(URL_MIO, {
                method: 'post',
                body
            })
                .then(a => a.json())
                .then(r => {
                    // eslint-disable-next-line
                    if (r.codigo == 1) {
                        traerExcel(r.id)
                    } else {
                        // eslint-disable-next-line
                        if (r.codigo == 2) {
                            setAlertaCamposRequeridos(true)
                        } else {
                            alert(r.mensaje)
                        }
                    }
                })
                .catch(a => {
                    elToast('Hubo un error al guardar la salida, por favor intentalo nuevamente.', 'error')
                })
                .finally(() => {
                    setCargandobtn(false)
                })

        } else {
            setAlertaCamposRequeridos(true)
        }

    }




    function traerExcel(id) {
        setCargandoDocumento(true)
        elToast('Generando archivo...', 'esperar')

        let body = new FormData()
        body.append('id', id)

        fetch(SERVIDOR+'/funciones/exportar_formato_salida.php', {
            body,
            method: 'POST'
        })
            .then(response => response.blob())
            .then(blob => {
                // Crea un enlace de descarga
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = 'Formato_de_salida.xlsx';
                link.click();
                elToast('Archivo generado exitosamente', 'exito')
            })
            .catch(e => {
                elToast('Hubo un error al generar el archivo de excel, por favor intentalo nuevamente', 'error')
            })
            .finally(() => setCargandoDocumento(false))
    }



    // useEffects
    useEffect(() => {
        traerJefes()
        // eslint-disable-next-line
    }, [])



    return {
        formSalida, setFormSalida, jefes, cargando, alertaCamposRequeridos, guardarSalida,
        quienAutoriza, setQuienAutoriza, cargandoDocumento, cargandobtn, fecha, setFecha
    }
}

